import { connect } from 'react-redux';

import { NotificationError, NotificationErrorProps } from '../../components/NotificationError/NotificationError';
import { LocalStorage, StorageKeyType } from '../../service/Storage/Storage';
import { State } from '../../typings/state';
import { TStateProps } from '../../typings/utils';

const DIFF_TIMESTAMP_RETRY_VIEW = 1800000; // 30 минут

export type StateProps = TStateProps<NotificationErrorProps>;

export const mapStateToProps = (state: State): StateProps => {
    const { constants } = state.commonData;
    const alertData = constants ? constants.alertData : undefined;
    const timestampLastViewNotificationError = LocalStorage.getItem(
        StorageKeyType.timestampLastViewNotificationError
    ) as number;
    const timestampNow = Date.now();

    if (
        timestampLastViewNotificationError &&
        timestampNow - timestampLastViewNotificationError < DIFF_TIMESTAMP_RETRY_VIEW &&
        alertData
    ) {
        alertData.enabled = false;
    }

    return {
        alertData: alertData
    };
};

export const NotificationErrorContainer = connect<StateProps, {}, {}>(mapStateToProps)(NotificationError);
